export const FONT_SIZE_TOKEN = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
];
export const FONT_SIZE = {
    A: 8,
    B: 9,
    C: 10,
    D: 11,
    E: 13,
    F: 14,
    G: 16,
    H: 18,
    I: 20,
    J: 23,
    K: 26,
    L: 29,
    M: 32,
    N: 36,
    O: 41,
    P: 46,
    Q: 52,
    R: 58,
    S: 66,
    T: 74,
    U: 83,
    V: 94,
    W: 105,
    X: 118,
    Y: 133,
    Z: 150,
};
